export { default as documentRoutes } from "./document-routes";
